import { useState } from "react";
import { SketchPicker } from "react-color";
import { Card, CardBody, Button } from "reactstrap";

const ColorPicker = ({ value, onChange, isToggle = false }) => {
  const [displayPicker, setDisplayPicker] = useState(isToggle);

  const togglePicker = () => {
    setDisplayPicker(!displayPicker);
  };

  const handleColorChange = (color) => {
    onChange(color.hex); // send hex color to parent
  };

  return (
    <div>
      <div onClick={togglePicker} style={{ cursor: "pointer" }}>
        <Button
          type="button"
          className="btn"
          style={{ backgroundColor: value }}
        >
          {value}
        </Button>
      </div>

      {displayPicker && (
        <SketchPicker
          color={value}
          width="250px"
          onChangeComplete={handleColorChange}
        />
      )}
    </div>
  );
};

export default ColorPicker;
